import React, { useEffect, useState } from 'react'
import { BsTelephoneFill } from 'react-icons/bs'
import { FaEye } from 'react-icons/fa'
import { Modal } from 'react-bootstrap'
import { Link } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { HiMailOpen } from 'react-icons/hi'
import { useCookies } from 'react-cookie'
import { decreaseContact } from '../../Redux/features/User/userSlice'

function MatchContact({ match, isConnected }) {
    const { user } = useSelector(state => state.user)
    const [showEmail, setShowEmail] = useState("show")
    const [showPhone, setShowPhone] = useState("show")
    const [showWhatsApp, setShowWhatsApp] = useState("show")
    const [email, setEmail] = useState("")
    const [mobile, setMobile] = useState("")
    const [whatsApp, setWhatsApp] = useState("")
    const dispatch = useDispatch()
    //eslint-disable-next-line
    const [cookies, setCookie] = useCookies(['x-auth-token']);

    useEffect(() => {
        if (match?.privacy?.email === "hide") {
            setShowEmail("hide")
        } else if (match?.privacy?.email === "like" && !isConnected) {
            setShowEmail("like")
        } else if (match?.privacy?.email === "premium" && user?.userStatus.membership.membershipType === "Free") {
            setShowEmail("premium")
        } else if (match?.privacy?.email === "likeAndPremium" && ((user?.userStatus.membership.membershipType === "Free") || isConnected)) {
            setShowEmail("premium")
        } else if (match?.privacy?.email === "likeAndPremium" && ((user?.userStatus.membership.membershipType !== "Free") || !isConnected)) {
            setShowEmail("like")
        } else {
            setEmail(match?.email)
        }

        if (match?.privacy?.mobile === "hide") {
            setShowPhone("hide")
        } else if (match?.privacy?.mobile === "like" && !isConnected) {
            setShowPhone("like")
        } else if (match?.privacy?.mobile === "premium" && user?.userStatus.membership.membershipType === "Free") {
            setShowPhone("premium")
        } else if (match?.privacy?.mobile === "likeAndPremium" && ((user?.userStatus.membership.membershipType === "Free") || isConnected)) {
            setShowPhone("premium")
        } else if (match?.privacy?.mobile === "likeAndPremium" && ((user?.userStatus.membership.membershipType !== "Free") || !isConnected)) {
            setShowPhone("like")
        } else {
            setMobile(match?.mobile)
        }
        if (match?.privacy?.whatsApp === "hide") {
            setShowWhatsApp("hide")
        } else if (match?.privacy?.whatsApp === "like" && !isConnected) {
            setShowWhatsApp("like")
        } else if (match?.privacy?.whatsApp === "premium" && user?.userStatus.membership.membershipType === "Free") {
            setShowWhatsApp("premium")
        } else if (match?.privacy?.whatsApp === "likeAndPremium" && ((user?.userStatus.membership.membershipType === "Free") || isConnected)) {
            setShowWhatsApp("premium")
        } else if (match?.privacy?.whatsApp === "likeAndPremium" && ((user?.userStatus.membership.membershipType !== "Free") || !isConnected)) {
            setShowWhatsApp("like")
        } else {
            setWhatsApp(match?.whatsApp)
        }
        //eslint-disable-next-line
    }, [match, isConnected, user?.userStatus.membership.membershipType])
    const [show, setShow] = useState(false);

    const handleClose = () => setShow(false);
    const handleShow = async () => {
        setShow(true)
        const content = {
            data: {
                email: "",
                mobile: "",
                whatsApp: "",
                id: match?._id
            },
            header: cookies['x-auth-token']
        }
        if (email) content.data.email = email
        if (mobile) content.data.mobile = mobile
        if (whatsApp) content.data.whatsApp = whatsApp
        dispatch(decreaseContact(content))
    }
    return (
        <>
            <Modal show={show} onHide={handleClose} centered>
                <Modal.Header closeButton>
                    <Modal.Title>Contact Card</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div>
                        <div className="contact-name">You are viewing Contact Details of <span>{match?.firstName} {match?.lastName}</span></div>
                        {showEmail === "show" && <div className="email-link">
                            <HiMailOpen size={25} />
                            <Link to={`mailto:${match?.email}`}>
                                {match?.email}
                            </Link>
                        </div>}
                        {showPhone === "show" && <div className="phone-link">
                            <BsTelephoneFill size={25} />
                            <Link to={`tel:${match?.mobile}`}>
                                {match?.mobile}
                            </Link>
                        </div>}
                        {showWhatsApp === "show" && <div className="phone-link">
                            <BsTelephoneFill size={25} />
                            <Link to={match?.whatsApp}>
                                {match?.whatsApp}
                            </Link>
                        </div>}
                    </div>
                    <div className="contact-border"></div>
                    <div className='contact-bottom'>
                        <div><Link>Report Number</Link></div>
                        <div className="left-contact fw-bold">
                            Contact Views Left: <span className="text-danger">{user?.userStatus?.membershipDetails?.viewContacts}</span>
                        </div>
                    </div>
                </Modal.Body>
            </Modal>
            <div>
                {((showEmail === "show" || showPhone === "show" || showWhatsApp === "show" ) && user?.userStatus?.membership.membershipType !=="Free") && <button onClick={() => handleShow()} className='view-contact-btn'>
                    <FaEye /> View Contact
                </button>}
                {(showEmail === "hide" && showPhone === "hide" && showWhatsApp === "hide") && <button disabled className='view-contact-btn'>
                    <FaEye /> Contact Details Hidden
                </button>}
                {(showEmail === "premium" || showPhone === "premium" || showWhatsApp === "premium" ) && <button disabled className='view-contact-btn'>
                    <FaEye /> Upgrade to Premium
                </button>}
                {(showEmail === "like" && showPhone === "like" && showWhatsApp === "like") && <button disabled className='view-contact-btn'>
                    <FaEye /> You Need to connect first
                </button>}
            </div>
        </>
    )
}

export default MatchContact